import { CLIENT_LOCATION_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
const LOCATION_CACHE = {
    value: '',
};
export function cachedClientLocationCountry() {
    return LOCATION_CACHE.value;
}
export function getClientLocationCountry() {
    if (LOCATION_CACHE.value) {
        return Promise.resolve(LOCATION_CACHE.value);
    }
    // do not allow multiple requests to be sent if there is already one active
    if (LOCATION_CACHE.activePromise) {
        return LOCATION_CACHE.activePromise;
    }
    LOCATION_CACHE.activePromise = Network.get(CLIENT_LOCATION_ENDPOINT)
        .then((response) => {
        const { clientCountryCode } = response.data;
        LOCATION_CACHE.value = clientCountryCode;
        return clientCountryCode;
    })
        .catch(() => {
        return '';
    })
        .finally(() => {
        LOCATION_CACHE.activePromise = undefined;
    });
    return LOCATION_CACHE.activePromise;
}
